// Notifications.jsx

import { useState } from "react";
import "./Notifications.css";
import {
  FaCube,
  FaCreditCard,
  FaExclamationTriangle,
  FaUsers,
  FaCheckCircle,
  FaRegClock,
} from "react-icons/fa";
import Header from "../Components/Header";

const Notifications = () => {
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      title: "New Order Placed",
      desc: "Order #ORD-1001 has been placed by Priya Sharma",
      time: "2 minutes ago",
      icon: <FaCube />,
      color: "blue",
      unread: true,
    },
    {
      id: 2,
      title: "Payment Received",
      desc: "Payment of ₹12,500 received for Order #ORD-1001",
      time: "15 minutes ago",
      icon: <FaCreditCard />,
      color: "green",
      unread: true,
    },
    {
      id: 3,
      title: "Low Stock Alert",
      desc: "Banarasi Silk Saree - Only 5 items left in stock",
      time: "1 hour ago",
      icon: <FaExclamationTriangle />,
      color: "orange",
      unread: true,
    },
    {
      id: 4,
      title: "New Customer Registered",
      desc: "Ananya Gupta has registered as a new customer",
      time: "2 hours ago",
      icon: <FaUsers />,
      color: "purple",
      unread: false,
    },
    {
      id: 5,
      title: "Order Shipped",
      desc: "Order #ORD-1002 has been shipped successfully",
      time: "3 hours ago",
      icon: <FaCube />,
      color: "blue",
      unread: false,
    },
    {
      id: 6,
      title: "Product Added",
      desc: "Chanderi Kurta Set has been added to inventory",
      time: "5 hours ago",
      icon: <FaCheckCircle />,
      color: "green",
      unread: false,
    },
  ]);

  const unreadCount = notifications.filter((item) => item.unread).length;

  const markAllRead = () => {
    setNotifications((prev) =>
      prev.map((item) => ({ ...item, unread: false }))
    );
  };

  return (
    <div className="notifications-page">
      <Header />
      {/* Top Header */}
      <div className="notifications-top">
        <div>
          <h1>Notifications</h1>
          <p>You have {unreadCount} unread notifications</p>
        </div>

        <button onClick={markAllRead}>Mark All as Read</button>
      </div>

      {/* List */}
      <div className="notifications-box">
        {notifications.map((item) => (
          <div className="notification-row" key={item.id}>
            <input type="checkbox" />

            <div className={`icon-box ${item.color}`}>
              {item.icon}
            </div>

            <div className="notification-info">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>

            <div className="notification-right">
              <FaRegClock className="clock" />
              <span>{item.time}</span>

              {item.unread && <div className="red-dot"></div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Notifications;